module.exports = __webpack_public_path__ + "static/media/Offer.049dd719.png";